module.exports = __webpack_public_path__ + "img/noto_kiss-mark_4.e18c7cbc.png";